// extracted by mini-css-extract-plugin
module.exports = {"modal":"leave-modal_modal__T_62I","actions":"leave-modal_actions__3fNnX","message":"leave-modal_message__3dsj_"};